<template>
  <div class="filePreview">
    <div class="header">
      <div class="header-left">
        <span class="back" @click="goBack()"></span>
        <span class="file-name">{{queryData.name}}</span>
        <span
              class="language">{{$i18n.locale === 'zh' ? queryData.langDesc.replace('>', ' — ') : $langCase[queryData.sourceLang] + ' — '+ $langCase[queryData.targetLang]}}</span>
      </div>
      <div class="header-center">
        <span class="left" @click="pageReduce"></span>
        <span class="page">{{$t('fileManagement.currentPage')}} </span>
        <el-input @change="changePage" v-model="page"
                  oninput="value=value.replace(/^(0+)|[^\d]+/g,'')"></el-input>
        /
        <span class="total-page">{{total}}</span>
        <span class="right" @click="addPage"> </span>
      </div>
      <div class="header-right">
        <el-select v-model="textType" :placeholder="$t('project.pleaseChoose')"
                   @change="changeTextType()">
          <el-option v-for="(item,index) in options" :key="index" :label="item.label"
                     :value="item.value">
          </el-option>
        </el-select>

        <el-popover placement="left" trigger="click" popper-class="setting-list" ref="popover"
                    @after-leave="downloadHide">
          <el-cascader-panel :options="projectOptionChange()" :props='props' v-model="downloadStr"
                             @change='downloadFile($event)'>
          </el-cascader-panel>
          <!-- <span slot="reference" class="item-down"></span> -->
          <el-button slot="reference" icon="download">{{$t('projectDetailsV2.download')}}
          </el-button>
        </el-popover>

        <el-button icon="print" @click="print">{{$t('fileManagement.print')}}</el-button>

      </div>
    </div>
    <!-- 页面文字展示 -->
    <div class="text-content" id="myPrint">

      <div class="left printBox" v-show="textType == 1">
        <p v-for="(item , index ) in text " :key="index" :class="specialLangClassName('source')">
          {{getArticle(JSON.parse(item.tagSourceSent).fragments[0].atoms)}}
        </p>
      </div>
      <div class="right printBox" v-show="textType == 1">
        <p v-for="(item , index ) in text " :key="index" :class="specialLangClassName('target')">
          {{getArticle(JSON.parse(item.tagTargetSent).fragments[0].atoms)}}
        </p>
      </div>

      <div class="up-down printBox" v-show="textType == 2">
        <p v-for="(item , index ) in text" :key="index">
          <span class="up-downtext up-downText-source" :class="specialLangClassName('source')">
            {{getArticle(JSON.parse(item.tagSourceSent).fragments[0].atoms)}}
          </span>
          <span class="up-downtext up-downText-target"
                :class="specialLangClassName('target')">{{getArticle(JSON.parse(item.tagTargetSent).fragments[0].atoms)}}</span>
        </p>
      </div>

      <div class="original printBox" v-show="textType == 3">
        <p v-for="(item , index ) in text " :key="index" :class="specialLangClassName('source')">
          <span> {{getArticle(JSON.parse(item.tagSourceSent).fragments[0].atoms)}}</span>
        </p>
      </div>
      <div class="translation printBox" v-show="textType == 4">
        <p v-for="(item , index ) in text " :key="index" :class="specialLangClassName('target')">
          <span>{{getArticle(JSON.parse(item.tagTargetSent).fragments[0].atoms)}}</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { getDownloadAsyncResult, exportAsyncTransFile, exportTransFileXlf, exportTransFileTmx } from '@/services/projectDetailsApi';
import { apiRoot } from '@/services/ajax';
import { originalTranslation } from "@/services/fileManage";
import * as Printjs from "print-js";
export default {
  name: "filePreview",
  data() {
    return {
      SPECIAL_LANGUAGE: SPECIAL_LANGUAGE,
      queryData: {},
      downloadStr: "",
      textType: 1,
      options: [{
        value: 1,
        label: this.$t('task.leftRight')
      }, {
        value: 2,
        label: this.$t('task.upDown')
      }, {
        value: 3,
        label: this.$t('project.originalText')
      }, {
        value: 4,
        label: this.$t('projectV2.translation')
      }],
      props: {
        expandTrigger: 'hover',
        emitPath: false,
      },
      page: 1,
      rows: 10,
      total: null,
      text: [],
    }
  },
  created() {
    this.queryData = JSON.parse(this.$Base64.decode(this.$route.query.key));
    console.log(this.queryData);
    this.changeTextType()
  },
  methods: {
    specialLangClassName(source) {
      const { sourceLang, targetLang } = this.queryData
      if (source === 'source') {
        return this.SPECIAL_LANGUAGE.indexOf(sourceLang) !== -1 ? 'right-view' : ''
      } else if (source === 'target') {
        return this.SPECIAL_LANGUAGE.indexOf(targetLang) !== -1 ? 'right-view' : ''
      }
    },
    //获取原文译文
    getArticle(arr) {
      let array = arr.filter(item => {
        return item.dataType == "text"
      })
      let textArr = []
      array.forEach(item => {
        textArr.push(item.data)
      })
      return textArr.join("")
    },
    print() {
      let style = ''
      const pageStyle = '@page { size:auto; }';
      let printStyle = '@media print { .text-content{display: flex;justify-content: space-between;word-break:break-word} .left{ width: 49.52%;.}.up-downtext{display:block} .right{ width: 49.52%}';
      const { sourceLang, targetLang } = this.queryData
      if (this.SPECIAL_LANGUAGE.indexOf(sourceLang) !== -1) {
        printStyle += '.up-downText-source,.left,.original{ text-align: right !important; direction: rtl;unicode-bidi: bidi-override;}'
      } else if (this.SPECIAL_LANGUAGE.indexOf(targetLang) !== -1) {
        printStyle += '.up-downText-target,.right,.translation{ text-align: right !important; direction: rtl;unicode-bidi: bidi-override;}'
      }
      style = pageStyle + printStyle
      let printDiv = document.querySelectorAll('.printBox');
      printDiv.forEach(item => {
        item.style.overflow = 'visible'
      })
      Printjs({
        printable: "myPrint",
        type: "html",
        targetStyles: ['*'],
        documentTitle: this.queryData.name,
        font_size: '14px',
        maxWidth: 10000,
        maxHeight: 3508,
        scanStyles: false,
        style: style,
      });
      printDiv.forEach(item => {
        item.style.overflow = 'auto'
      })
    },
    changePage() {
      if (this.page > this.total) {
        this.page = this.total
      }
      this.getOriginalTranslation()
    },
    addPage() {
      this.page++
      if (this.page > this.total) {
        this.page = this.total
        return
      }
      this.getOriginalTranslation()
    },
    pageReduce() {
      if (this.page > 1) {
        this.page--
      } else {
        return
      }
      this.getOriginalTranslation()
    },
    changeTextType() {
      this.page = 1
      this.rows = 10,
        this.getOriginalTranslation()
    },
    async getOriginalTranslation() {
      if (this.page == "") {
        return
      }
      let params = {
        marker: 2,
        row: this.rows,
        showTerm: 1,
        startSort: this.page,
        taskType: 1,
        transFileId: this.queryData.id,
        comparedHighlight: 0,
      }
      const { success, result } = await originalTranslation(params)
      if (success) {
        this.total = result.totalPage
        this.text = result.transSentRespVoList

      }
    },
    // 单个文件下载
    downloadFile(val) {
      let id = this.queryData.id;
      let type = null
      this.$refs.popover.doClose();
      switch (val) {
        case 'original':
          type = 6
          this.onDownload(type, id);
          break;
        case 'translate-translation':
          type = 1
          this.onDownload(type, id);
          break;
        case 'translate-contrast':
          type = 2
          this.onDownload(type, id);
          break;
        case 'proofread-translation':
          type = 3
          this.onDownload(type, id);
          break;
        case 'proofread-contrast':
          type = 4
          this.onDownload(type, id);
          break;
        case 'review-translation':
          type = 11
          this.onDownload(type, id);
          break;
        case 'review-contrast':
          type = 12
          this.onDownload(type, id);
          break;
        case 'modify':
          type = 5
          this.onDownload(type, id);
          break;
        case 'XLFreport':
          this.onDownloadXlf(id);
          break;
        case 'TMXreport':
          this.onDownloadTmx(id);
          break;
      }
    },
    //下载
    async onDownload(type, id) {
      let param = {
        type,
        fileId: id
      };
      let { resultCode, result } = await exportAsyncTransFile(param);
      if (resultCode !== "1") {
        return;
      }
      if (result.percent == 100) {
        this.downloadServerFile(result.fileName, result.downloadUrl)
      } else {
        this.isDownloadLoading = true;
        this.getDownloadAsyncResult(result.taskKey);
      }
    },
    async onDownloadXlf(id) {
      let { resultCode, result } = await exportTransFileXlf({ id });
      if (resultCode === '1') {
        window.open(result);
        this.isDownloadLoading = false;
      }
    },
    async onDownloadTmx(id) {
      let { resultCode, result } = await exportTransFileTmx({ id });
      if (resultCode === '1') {
        window.open(result);
        this.isDownloadLoading = false;
      }
    },
    // a链接下载
    downloadServerFile(fileName, filePath) {
      let link = document.createElement("a");
      link.style.display = "none";

      link.href = apiRoot(`/file/downloadServerFile?fileName=${fileName}&filePath=${filePath}`);
      link.setAttribute("download", fileName);

      document.body.appendChild(link);
      link.click();
    },
    // 轮询下载
    async getDownloadAsyncResult(taskKey) {
      let setItem = setInterval(async () => {
        let { resultCode, result } = await getDownloadAsyncResult({ taskKey });
        if (resultCode === "1") {
          if (parseInt(result.percent) === 100) {
            clearInterval(setItem);
            setItem = null;
            this.isDownloadLoading = false;
            this.downloadServerFile(result.fileName, result.downloadUrl)
          }
        } else {
          clearInterval(setItem);
          setItem = null;
          this.isDownloadLoading = false;
        }
      }, 2000);
    },
    // 级联隐藏
    downloadHide() {
      this.downloadStr = '';
    },
    //下载展开数据
    projectOptionChange() {
      return [
        { label: this.$t('projectV2.original'), value: 'original' },
        {
          label: this.$t('projectV2.translate'), value: 'translate', children: [
            { label: this.$t('projectV2.translation'), value: 'translate-translation' },
            { label: this.$t('projectV2.contrast'), value: 'translate-contrast' }
          ]
        },
        { label: this.$t('projectV2.revise'), value: 'modify' },
        { label: this.$t('projectV2.archive'), value: 'TMXreport' },
        { label: this.$t('projectV2.xlfreport'), value: 'XLFreport' },
      ];
    },
    goBack() {
      if (this.queryData.intoType === 'fileManage') {
        this.$router.push({
          name: 'fileManage',
        });
      } else if (this.queryData.intoType === 'fileSearch') {
        this.$router.push({
          name: 'fileSearch',
          params: {
            key: this.$Base64.encode(JSON.stringify({
              searchKeyword: this.queryData.routerData.keyword,
              sourceLang: this.queryData.routerData.sourceLang,
              targetLang: this.queryData.routerData.targetLang,
              domainCode: this.queryData.routerData.domainCode,
            })),
          },
          query: {
            key: this.$Base64.encode(JSON.stringify({
              searchType: 'fileManage',
            })),
          },
        });
      }
    },
  },
}
</script>

<style lang="less" scoped>
.filePreview {
  width: 100%;
  height: 100%;
  padding: 6px;
  box-sizing: border-box;
  .header {
    position: relative;
    width: 100%;
    height: 62px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .header-left {
      max-width: 38%;
      height: 32px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      span {
        display: block;
      }
      .back {
        cursor: pointer;
        min-width: 52px;
        height: 32px;
        border-radius: 4px;
        background: url("./assets/images/exit.png") no-repeat center;
      }
      .file-name {
        max-width: 455px;
        color: #262b30;
        font-weight: bold;
        font-size: 18px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        padding: 0 10px;
      }
      .language {
        height: 24px;
        line-height: 26px;
        font-size: 12px;
        color: #165dff;
        background: #e4eafb;
        padding: 0 8px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
    .header-center {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      display: flex;
      align-items: center;
      span {
        display: inline-block;
      }
      .left {
        width: 32px;
        height: 32px;
        border-radius: 50%;
        border: 1px solid #dfe2e6;
        background: url("./assets/images/left.png") no-repeat center;
        margin-right: 16px;
        cursor: pointer;

        &:hover {
          background: #fff url("./assets/images/left.png") no-repeat center;
        }
      }
      .right {
        width: 32px;
        height: 32px;
        border-radius: 50%;
        border: 1px solid #dfe2e6;
        background: url("./assets/images/right.png") no-repeat center;
        margin-left: 16px;
        cursor: pointer;
        &:hover {
          background: #fff url("./assets/images/right.png") no-repeat center;
        }
      }
      .page {
        color: #97a9bd;
        font-size: 14px;
      }
      .now-page {
        width: 30px;
        color: #165dff;
        font-size: 14px;
        overflow: hidden;
        white-space: nowrap;
      }
      /deep/.el-input {
        margin-right: 3px;
        width: 30px;
        height: 32px;
        .el-input__inner {
          line-height: 33px;
          color: #165dff;
          height: 32px;
          padding: 0;
          text-align: center;
        }
      }
      .total-page {
        color: #262b30;
        margin: 4px 0px 0px 3px;
      }
    }
    .header-right {
      display: flex;
      align-items: center;
      /deep/ .el-select {
        .el-input {
          width: 160px;
          height: 32px;
          .el-input__inner {
            height: 32px;
          }
        }
      }
      /deep/ .el-button {
        margin-left: 16px;
        padding: 0 8px;
        // width: 60px;
        height: 32px;
        color: #5d6674;
        font-size: 12px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .download {
          margin-right: 3px;
          display: inline-block;
          width: 16px;
          height: 16px;
          background: url("./assets/images/down.png") no-repeat center;
        }
        .print {
          margin-right: 3px;
          display: inline-block;
          width: 16px;
          height: 16px;
          background: url("./assets/images/print.png") no-repeat center;
        }
      }
    }
  }
  .text-content {
    width: 100%;
    height: calc(100% - 62px);
    display: flex;
    align-items: center;
    justify-content: space-between;
    .right-view {
      text-align: right !important;
      direction: rtl !important;
      unicode-bidi: bidi-override !important;
    }
    div {
      width: 49.52%;
      height: 100%;
      background: #fff;
      overflow-y: auto;

      box-sizing: border-box;
      p {
        padding: 16px;
        text-align: left;
        span {
          display: block;
        }
      }
    }
    .up-down {
      width: 100%;
    }
    .original {
      width: 100%;
    }
    .translation {
      width: 100%;
    }
  }
}
</style>
<style lang="less">
.setting-list {
  padding: 0;
  .el-cascader-panel {
    .el-cascader-menu {
      min-width: 130px;
      .el-scrollbar__wrap {
        // height: auto;
        ul {
          li {
            height: 32px;
            .el-icon-check {
              display: none;
            }
            .el-cascader-node__label {
              line-height: 32px;
            }
          }
        }
      }
    }
  }
}
</style>
